module.exports = __webpack_public_path__ + "img/swap-arrow.4bd06de5.svg";